export default "__VITE_ASSET__2af38323__"